// extracted by mini-css-extract-plugin
module.exports = {"progress-bar":"styles_progress-bar__KF5i7","percentage":"styles_percentage__AqUCn","arrow":"styles_arrow__KRlz_","bar":"styles_bar__0cbM5"};